import i18nLocale from "@/helpers/locale";
import { setCookie } from "@/helpers/cookies";
import json2csv from "json2csv";
import _ from "lodash";
import moment from "moment";
import { number_reg } from "@/utils/regExp";

export function toTableRowDateFormat(date) {
  return moment(date).format("YYYY-MM-DD");
}

export function revertToTableDateFormat(dateStr) {
  return moment(dateStr).valueOf();
}

// priceFormat
export function priceFormat(value, num, type) {
  let _num = num > 0 && num <= 20 ? num : 2;
  // let _value = String(String(parseFloat((value + '').replace(/[^\d\.-]/g, "")).toFixed(_num)) + "");
  let _value = String(parseFloat(String(value).replace(/[^\d.-]/g, "")).toFixed(_num));
  let valueArr = _value
    .split(".")[0]
    .split("")
    .reverse();
  const [_, valueFloat] = _value.split(".");
  let valueString = "";
  for (let i = 0; i < valueArr.length; i++) {
    valueString +=
      valueArr[i] + ((i + 1) % 3 == 0 && i + 1 != valueArr.length ? "," : "");
  }
  let price = "";
  if (type === "price") {
    price =
      valueString
        .split("")
        .reverse()
        .join("") +
      "." +
      valueFloat;
  } else {
    price = valueString
      .split("")
      .reverse()
      .join("");
  }
  return price;
}

export function dateFormat(date) {
  let d = date.replace(/-/g, "/");
  return new Date(d).getTime();
}

export function toThousands(num) {
  if (num === null || typeof num === "undefined") {
    return num;
  }

  let _num = (num || 0).toString(),
    re = /\d{3}$/,
    result = "";
  let point = "";
  if (_num.indexOf(".") !== -1) {
    point = _num.substring(_num.indexOf("."));
    _num = parseInt(_num);
  }
  while (re.test(_num)) {
    result = RegExp.lastMatch + result;
    if (_num !== RegExp.lastMatch) {
      result = "," + result;
      _num = RegExp.leftContext;
    } else {
      _num = "";
      break;
    }
  }
  if (_num) {
    result = _num + result;
  }

  function _(result) {
    return result.replace("-,", "-");
  }

  function __(result) {
    if (result[0] === ",") {
      let _result = result.substring(1);
      return _result;
    }
    return result;
  }

  function ___(result) {
    if (result[0] === ".") {
      let _result = "0" + result;
      return _result;
    }
    return result;
  }
  return ___(__(_(result) + point));
}

export function addCommas(nStr) {
  let _nStr = String(nStr).replace(/[^\d-]/g, "") || "0";
  let x = _nStr.split(".");
  let [x1, a] = x,
    x2 = x.length > 1 ? "." + a : "";
  let rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + "," + "$2");
  }
  return x1 + x2;
}
export function priceFormat_forPayable(num, form, key) {
  if (num) {
    form[key] = addCommas(form[key].replace(/,/g, ""));
  }
}

export function reverseThousandsFn(str) {
  if (!str) {
    return str;
  }
  return parseInt(str.toString().replace(/,/g, ""));
}

export function rounding(num, type = "ROUND", fixed, isString = false) {
  const divisor = fixed ? Math.pow(10, fixed) : 1;
  let result = 0;
  switch (type) {
  case "ROUND":
    result = fixed
      ? Math.round(num * divisor) / divisor
      : fixed === 0
        ? parseInt(Math.round(num))
        : Math.round(num);
    break;
  case "ROUND_DOWN":
    result = fixed
      ? Math.floor(num * divisor) / divisor
      : fixed === 0
        ? parseInt(Math.round(num))
        : Math.floor(num);
    break;
  case "ROUND_UP":
    result = fixed
      ? Math.ceil(num * divisor) / divisor
      : fixed === 0
        ? parseInt(Math.round(num))
        : Math.ceil(num);
    break;
  default:
    break;
  }
  return isString
    ? result % 1 === 0
      ? String(result) + ".0"
      : String(result)
    : result;
}

export const weekLocaleArray = [
  i18nLocale("calendar.sun"),
  i18nLocale("calendar.mon"),
  i18nLocale("calendar.tue"),
  i18nLocale("calendar.wed"),
  i18nLocale("calendar.thu"),
  i18nLocale("calendar.fri"),
  i18nLocale("calendar.sat"),
];

export const weekSelectArray = [
  { label: i18nLocale("calendar.sun"), value: "0", key: "SUN" },
  { label: i18nLocale("calendar.mon"), value: "1", key: "MON" },
  { label: i18nLocale("calendar.tue"), value: "2", key: "TUE" },
  { label: i18nLocale("calendar.wed"), value: "3", key: "WED" },
  { label: i18nLocale("calendar.thu"), value: "4", key: "THU" },
  { label: i18nLocale("calendar.fri"), value: "5", key: "FRI" },
  { label: i18nLocale("calendar.sat"), value: "6", key: "SAT" },
];

export const weekSelectArray2 = [
  {
    label: i18nLocale("calendar.sun") + i18nLocale("calendar.weekday"),
    value: 0,
    key: "SUN",
  },
  {
    label: i18nLocale("calendar.mon") + i18nLocale("calendar.weekday"),
    value: 1,
    key: "MON",
  },
  {
    label: i18nLocale("calendar.tue") + i18nLocale("calendar.weekday"),
    value: 2,
    key: "TUE",
  },
  {
    label: i18nLocale("calendar.wed") + i18nLocale("calendar.weekday"),
    value: 3,
    key: "WED",
  },
  {
    label: i18nLocale("calendar.thu") + i18nLocale("calendar.weekday"),
    value: 4,
    key: "THU",
  },
  {
    label: i18nLocale("calendar.fri") + i18nLocale("calendar.weekday"),
    value: 5,
    key: "FRI",
  },
  {
    label: i18nLocale("calendar.sat") + i18nLocale("calendar.weekday"),
    value: 6,
    key: "SAT",
  },
];

export const weekSelectArrayForMovie = [
  {
    label: i18nLocale("calendar.sun") + i18nLocale("calendar.weekday"),
    value: 7,
    key: "SUN",
  },
  {
    label: i18nLocale("calendar.mon") + i18nLocale("calendar.weekday"),
    value: 1,
    key: "MON",
  },
  {
    label: i18nLocale("calendar.tue") + i18nLocale("calendar.weekday"),
    value: 2,
    key: "TUE",
  },
  {
    label: i18nLocale("calendar.wed") + i18nLocale("calendar.weekday"),
    value: 3,
    key: "WED",
  },
  {
    label: i18nLocale("calendar.thu") + i18nLocale("calendar.weekday"),
    value: 4,
    key: "THU",
  },
  {
    label: i18nLocale("calendar.fri") + i18nLocale("calendar.weekday"),
    value: 5,
    key: "FRI",
  },
  {
    label: i18nLocale("calendar.sat") + i18nLocale("calendar.weekday"),
    value: 6,
    key: "SAT",
  },
];

export const salesStatus = {
  success: i18nLocale("trans.report.status.success"),
  cancel: i18nLocale("trans.report.status.cancel"),
  delete: i18nLocale("trans.report.status.delete"),
  expired: i18nLocale("trans.report.status.expired"),
  fail: i18nLocale("trans.report.status.fail"),
  parital_refunded: i18nLocale("trans.report.status.partial_refunded"),
  processing: i18nLocale("trans.report.status.processing"),
  refunded: i18nLocale("trans.report.status.refunded"),
  confirming: i18nLocale("trans.report.status.fail"),
  pendingPayment: i18nLocale("trans.report.status.pending"),
};

export const taxRatesMap = {
  "-1.1": i18nLocale("trans.report.taxrate.map.non"),
  "0": i18nLocale("global.dutyFree"),
  "0.08": i18nLocale("trans.report.taxrate.map.percenteight"),
  "0.1": i18nLocale("trans.report.taxrate.map.percentTen"),
};

export const taxRateOpts = [0.1, 0.08, 0, -1.1];

export const subTitleMap = {
  DUB: i18nLocale("trans.report.version2.dub"),
  NONE: i18nLocale("trans.report.version2.none"),
  SUBTITLE: i18nLocale("trans.report.version2.subtitle"),
};

export const subTitleOpts = ["NONE", "DUB", "SUBTITLE"];

export const booleanOptions = [
  {
    label: i18nLocale("global.yes"),
    value: true,
  },
  {
    label: i18nLocale("global.no"),
    value: false,
  },
];

export const formInvalidHandle = () => {
  setTimeout(() => {
    const isError = document.getElementsByClassName("is-error");
    if (isError[0].querySelector("input")) {
      isError[0].querySelector("input").focus();
    } else if (isError[0].querySelector("i")) {
      isError[0].querySelector("i").focus();
    } else if (isError[0].querySelector("button")) {
      isError[0].querySelector("button").focus();
    }
  }, 100);

  return false;
};

// export function numberFormat(value, form) {
//   if (value) {
//     form.needPayAmount = typeof form.needPayAmount === "number" ?
//       toThousands(form.needPayAmount) : toThousands(parseInt(form.needPayAmount.replace(/,/g, "")));
//   }
// }

export const accountingFunctionsMap = {
  cash: i18nLocale("accounting.management.cash"),
  odyDeposit: i18nLocale("accounting.management.odyDeposit"),
  accReceivable: i18nLocale("accounting.management.accReceivable"),
  otherReceivable: i18nLocale("accounting.management.otherReceivable"),
  inventory: i18nLocale("accounting.management.inventory"),
  otherAssets: i18nLocale("accounting.management.otherAssets"),
  accPayable: i18nLocale("accounting.management.accPayable"),
  otherPayable: i18nLocale("accounting.management.otherPayable"),
  accuredExp: i18nLocale("accounting.management.accuredExp"),
  advancePay: i18nLocale("accounting.management.advancePay"),
  deposit: i18nLocale("accounting.management.deposit"),
  tempReceipt: i18nLocale("accounting.management.tempReceipt"),
  otherDebt: i18nLocale("accounting.management.otherDebt"),
  earnings: i18nLocale("accounting.management.earnings"),
  costOfSales: i18nLocale("accounting.management.costOfSales"),
  adminExp: i18nLocale("accounting.management.adminExp"),
  nonopIncome: i18nLocale("accounting.management.nonopIncome"),
  nonopExp: i18nLocale("accounting.management.nonopExp"),
  suspenseAcc: i18nLocale("accounting.management.suspenseAcc"),
};

export const accountingOpts = [
  "cash",
  "odyDeposit",
  "accReceivable",
  "otherReceivable",
  "inventory",
  "otherAssets",
  "accPayable",
  "otherPayable",
  "accuredExp",
  "advancePay",
  "deposit",
  "tempReceipt",
  "otherDebt",
  "earnings",
  "costOfSales",
  "adminExp",
  "nonopIncome",
  "nonopExp",
  "suspenseAcc",
];

export const taxRateTranf = key => {
  const taxRateMapping = {
    percenteight: 0.08,
    percentTen: 0.1,
    non: 0,
    zero: 0,
  };

  return taxRateMapping[key];
};

export const paymentTypeOpts = [
  "cash",
  "creditCard",
  "gmo",
  "cash380",
  "creditCard3000",
];

export function numberFormat(value, form, type) {
  if (value.target.value) {
    if (type === "format") {
      form.needPayAmount =
        typeof form.needPayAmount === "number"
          ? toThousands(form.needPayAmount)
          : toThousands(parseInt(form.needPayAmount.replace(/,/g, "")));
    } else {
      form.needPayAmount =
        form.needPayAmount !== "" && typeof form.needPayAmount === "string"
          ? parseInt(form.needPayAmount.replace(/,/g, ""))
          : form.needPayAmount;
    }
  }
}
export const kioskOpts = ["project", "product", "food", "fee", "other"];

export const kioskMaps = {
  project: i18nLocale("shop.kiosk.groups.programs"),
  product: i18nLocale("shop.kiosk.groups.goods"),
  food: i18nLocale("shop.kiosk.groups.food"),
  fee: i18nLocale("shop.kiosk.groups.memberFee"),
  other: i18nLocale("shop.kiosk.groups.others"),
};

export const saleForm = ["SALES_ITEM", "CONSIGNMENT"];

export const saleFormMap = {
  SALES_ITEM: i18nLocale("global.purchase"),
  CONSIGNMENT: i18nLocale("global.entrust"),
};

export const calcTax = ({
  price,
  taxRate,
  type = "ROUND",
  isIncreaseTax = true,
  fixed = 0,
}) => {
  //  This tax rate calculation has some problem.
  //  For example of 100 (10% tax) the without tax amount is 91 instead of 90 like the calculation here
  //  Please use math.js instead taxOff and taxAdd functions
  const _price = Number(price);
  if (typeof _price !== "number") {
    return 0;
  }

  const _taxRate = taxRate > 0 ? taxRate : 0;
  let _result = isIncreaseTax
    ? parseFloat(_price * (1 + _taxRate))
    : parseFloat(_price / (1 + _taxRate));

  if (isNaN(_result)) {
    _result = 0;
  }
  _result = rounding(_result, type, fixed);

  return _result;
};

/** @description 保存需要的localStorage
 * @param obj 需要添加的对象
 * @param key 需要添加的key
 */
const saveRequiredData = (obj, key) => {
  const arrsKey = [ "movie_filterOptions" ];
  const isArray = arrsKey.includes(key);
  window.localStorage.setItem(key, obj || JSON.stringify(isArray ? [] : {}));
};
export const clearBrowserData = () => {
  // 需要保存的数据在清除前先保存
  const userOptions = window.localStorage.getItem("userOptions");
  const version = window.localStorage.getItem("APP_VERSION");

  window.localStorage.clear();
  window.sessionStorage.clear();
  setCookie("token", "", -1);
  setCookie("loginAsAccountId", "", -1);

  // 保存数据
  saveRequiredData(userOptions, "userOptions");
  saveRequiredData(version, "APP_VERSION");
};

export const adminTypeList = {
  SUP_AMIN: "superAdmin",
  BRAND: "brand",
  CINEMA: "cinema",
};

// csv
export const json2csv_fn = (csvData, fields, fileName) => {
  try {
    // let _data = JSON.parse(JSON.stringify(csvData))
    // console.log(_data)
    // _data[0].name = "#####/###" + _data[0].name
    const result = json2csv.parse(
      csvData,
      fields.length === 0 ? { header: false } : { fields }
    );
    let csvContent = "data:text/csv;charset=utf-8,\uFEFF" + encodeURIComponent(result);
    let link = document.createElement("a");
    link.href = csvContent;
    link.download = fileName + ".csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.error(err);
  }
};

export const checkValidData = _obj => {
  const resultArray = [];
  Object.keys(_obj).forEach(key => {
    const _invalid = !_obj[key];
    // const _invalid = typeof _obj[key] === "undefined" || _obj[key] === null || _obj[key] === "";
    resultArray.push(!_invalid);
  });

  return resultArray.find(item => item === true);
};

export const digtalParser = (value, negative) => {
  if (value === "" || value === null || typeof value === "undefined") {
    return "";
  }

  let _value = String(value);
  _value = _value.replace(/[¥,\s]/g, "");

  if (_value === "0" || _value === "" || (_value === "-" && negative)) {
    return _value;
  }
  if (_value === "-0") {
    return "-";
  }

  if (negative) {
    const _reg = /[^-0-9]{1}[^0-9]*/;
    const _reg2 = /[^0-9]$/;
    _value = _value.replace(_reg, "").replace(_reg2, "");
  } else {
    const _reg = /[^0-9]*/gi;
    _value = _value.replace(_reg, "");
  }

  return _value === "" ? "" : Number(_value);
};

export const categoryMapping = {
  notice: i18nLocale("sideMenu.cinemaWebsite.news.category.notice"),
  importantNotice: i18nLocale("sideMenu.cinemaWebsite.news.category.importantNotice"),
  activity: i18nLocale("sideMenu.cinemaWebsite.news.category.activity"),
  send: i18nLocale("sideMenu.cinemaWebsite.news.category.send"),
  campaign: i18nLocale("sideMenu.cinemaWebsite.news.category.campaign")
};

export const setStorageModule_fn = (type, val) => {
  const curCinemaId = window.localStorage.getItem("cinemaId");
  let userOptions = JSON.parse(window.localStorage.getItem("userOptions")) || [];
  let curUserOptionIdx = userOptions.findIndex(item => item.cinemaId === curCinemaId);
  if (userOptions.length > 0 && curUserOptionIdx !== -1) {
    let curUserOption = userOptions[curUserOptionIdx];
    const curModuleIdx = curUserOption.module.findIndex(item => item.type === type);
    curUserOption.cinemaId = curCinemaId;
    if (curModuleIdx !== -1) {
      curUserOption.module[curModuleIdx] = {
        ...curUserOption.module[curModuleIdx],
        data: val
      };
    } else {
      curUserOption.module.push({
        type,
        data: val
      });
    }
    userOptions[curUserOptionIdx] = curUserOption;
  } else {
    userOptions.push({
      cinemaId: curCinemaId,
      module: [
        {
          type,
          data: val
        }
      ]
    });
  }
  window.localStorage.setItem("userOptions", JSON.stringify(userOptions));
};
// verification number
const verifyIsNumber = val => {
  return number_reg.test(val);
};

// only Input Number
export const inputNumber_fn = (val, callback) => {
  const _val = verifyIsNumber(val) ? val : "";
  typeof callback === "function" && callback(_val);
};

// getRankListWithId
export const getRankListForMemberShipIds = (ids, list) => {
  if (ids.length === 0) {
    return [];
  }
  const compareObjects = (obj1, id) => {
    return obj1.id === id;
  };
  const _ids = (ids && ids.length > 0 && ids.indexOf("all") > -1) ? list.map(item => item.id) : ids;
  const resultArr = _.intersectionWith(list, _ids, compareObjects);
  let _arr = [];
  const filterList = resultArr.filter(item => item.rankList && item.rankList.length > 0);
  filterList.forEach(item => {
    item.rankList.forEach(rank => {
      _arr.push({
        uuid: rank.uuid,
        name: `${rank.name}(${item.name})`
      });
    });
  });
  if (filterList.length) {
    // return [
    // {
    //   name: "全て",
    //   uuid: "all"
    // },
    // ].concat(...filterList)
    return [ ..._arr ];
  }
  return [];
};
export const getExportName_fn = (...arg) => {
  let _arr = [];
  arg.forEach(value => {
    if (value) {
      _arr.push(value);
    }
  });
  return _arr.join("_");
};

export const getCinemaDailyIdForName = list => {
  if ((list.find(item => item.name === "グッズ") || {})) {
    return (list.find(item => item.name === "グッズ") || {}).id;
  }
  return list[0].id;
};
export const getOperatorText = row => {
  const {
    platform,
    itemStatus,
    operator,
  } = row;
  // if (itemStatus !== 'refunded') {
  //   return `${platform}/${operator}`
  // } else {
  //   return `${platform.includes('[WEB] Online Ticketing') ? 'CMS' : platform}/${operator}`
  // }
  return `${platform}/${operator}`;
};
export const isValidDate = time => {
  return moment(time).isValid();
};
// 安全数组分解函数
export const safeJoin = (array, separator = ",", mapping = [], defaultValue = "") => {
  if (!Array.isArray(array) || (array && array.length === 0)) { return defaultValue; } // 如果不是数组，返回默认值
  return array
    .map(item => {
      // 判断映射类型
      if (Array.isArray(mapping)) {
        // 如果对象数组提供了映射规则，优先匹配 `value` 对应的 `name`
        const match = mapping.find(obj => obj.value === item);
        return match ? match.name : item; // 匹配成功返回 `name`，否则返回原始值
      } else if (typeof mapping === "object" && mapping !== null) {
        // 如果是纯对象，直接使用键值对进行映射
        return mapping[item] || item;
      }
      return item; // 没有映射规则，返回原始值
    })
    .filter(item => item !== null && item !== undefined) // 过滤无效值
    .join(separator);
};
// 安全日期格式化函数
export const safeFormateDate = (date, options = {}) => {
  const { format = "YYYY-MM-DD", strict = false, defaultDate = "" } = options;

  if (date === null || date === undefined || date === "") {
    return defaultDate;
  }

  const momentDate = strict ? moment(date, format, true) : moment(date);
  return momentDate.isValid() ? momentDate.format(format) : defaultDate;
};
export const formatStringFixed = str => {
  if (str === null || str === undefined) { return; }
  if (str.length <= 6) {
    // 字符串长度小于等于6直接返回
    return str;
  }
  // 分成两部分：前4个字符，和后4个字符
  const firstPart = str.slice(0, -6); // 前面的部分
  const lastFour = str.slice(-6);    // 后四个
  // 合并前部分和后四部分用空格隔开
  return `${firstPart} ${lastFour}`;
};

/**
 * 转换 HTTP URL 为可访问的 URL
 * @param httpUrl HTTP URL
 * @returns 转换后的 URL
 */
function convertHttpUrl(httpUrl) {
  // 尝试多种代理方案
  const proxies = [
    // 方案1：使用自己的代理服务（不编码 URL）
    () => `/image-proxy?url=${httpUrl}`,
    
    // 方案2：使用公共 CORS 代理
    () => `https://cors-anywhere.herokuapp.com/${httpUrl}`,
    
    // 方案3：使用其他公共代理
    () => `https://api.allorigins.win/raw?url=${httpUrl}`,
    
    // 方案4：直接返回（可能在某些环境下工作）
    () => httpUrl,
  ];

  // 默认使用第一个方案
  return proxies[0]();
}
export const convertImageUrl = originalUrl => {
  if (!originalUrl) {
    return "";
  }

  // 如果是 HTTPS URL，但实际需要 HTTP，转换为代理请求
  if (originalUrl.startsWith("https://")) {
    // 检查是否是已知的 HTTP 服务器
    const httpServers = [
      "piacinema3.xsrv.jp",
      // 添加其他需要强制使用 HTTP 的服务器
    ];

    try {
      const urlObj = new URL(originalUrl);
      if (httpServers.includes(urlObj.hostname)) {
        // 将 HTTPS 转换为 HTTP 并通过代理访问
        const httpUrl = originalUrl.replace("https://", "http://");
        return convertHttpUrl(httpUrl);
      }
    } catch (error) {
      console.warn("Invalid URL format:", originalUrl);
    }

    return originalUrl;
  }

  // 如果是 HTTP URL，通过代理访问
  if (originalUrl.startsWith("http://")) {
    return convertHttpUrl(originalUrl);
  }

  return originalUrl;
};
